import classnames from 'classnames';
import React, { useCallback } from 'react';
import useLabel from '../../utils/Translations/useLabel';
import useHelpNoteTitleIfPresent from '../../utils/Translations/useHelpNoteTitleIfPresent';
import DateRangePickerBase from '../base/DateRangePicker';
import styles from './DateRangePicker.scss';
const DateRangePicker = ({ hasTimePicker = false, value: { endDate, startDate } = {
    startDate: null,
    endDate: null,
}, onChange, isDisabled = false, isRequired = false, hasRange = false, noPadding = false, className = '', tdClassName = '', label, dataCy, }) => {
    const _label = useLabel('Date', label);
    const helpNoteTitle = useHelpNoteTitleIfPresent(label || 'Date');
    const _onChange = useCallback((startDate, endDate) => onChange &&
        onChange({
            endDate,
            startDate,
        }), [onChange]);
    return (<div className={classnames(className, {
        [styles.daterangepicker]: !noPadding,
    })} data-cy={dataCy}>
      <table className={styles.table}>
        <tbody>
          <tr>
            <td className={classnames(tdClassName, styles.customDisplay)}>
              <span className="text-semibold" title={helpNoteTitle}>
                {_label}:
              </span>
            </td>
            <td className={classnames(styles.td, styles.customDisplay, {
        [styles.tdWithTimePicker]: hasTimePicker,
    })}>
              <DateRangePickerBase animateTitle={false} className={classnames(styles.formGroup, 'customDatePickerWidth')} disabled={isDisabled} endDate={endDate} hasDurationMessage={false} hasRange={hasRange} hasTimePicker={hasTimePicker} placeholder="Select Date Range" required={isRequired} startDate={startDate} onChange={_onChange}/>
            </td>
          </tr>
        </tbody>
      </table>
    </div>);
};
export default DateRangePicker;
